<header>
  <h2 id="synthese-titre">Nouveautés depuis votre dernière connexion</h2>
  <p>Bonjour {{ prenom }}, voici les éléments à consulter.</p>
  <button type="button" class="croix" mat-dialog-close aria-label="Fermer la synthèse">
    <span class="material-symbols-outlined" aria-hidden="true">close</span>
  </button>
</header>
<div class="contenu">
  @if (erreur()) {
    <p role="alert">{{ erreur() }} <button type="button" (click)="charger()">Réessayer</button></p>
  } @else if (chargement()) {
    <p role="status">Chargement de la synthèse…</p>
  } @else {
    @for (rubrique of rubriques; track rubrique.id) {
      @let liste = listes()[rubrique.id];
      <section
        class="rubrique"
        [class.urgent]="rubrique.urgent"
        [class.depliee]="ouverte() === rubrique.id"
      >
        <button
          type="button"
          class="rubrique-entete"
          (click)="basculer(rubrique.id)"
          [attr.aria-expanded]="ouverte() === rubrique.id"
          [attr.aria-controls]="'synthese-' + rubrique.id"
        >
          <span class="material-symbols-outlined icone" aria-hidden="true">{{
            rubrique.icone
          }}</span>
          <span
            class="compteur"
            [title]="liste.total === null ? '' : liste.total + ' tickets'"
            [attr.aria-label]="
              liste.total === null ? 'Compteur indisponible' : liste.total + ' tickets'
            "
            >{{ formaterCompteur(liste.total) }}</span
          >
          <span class="libelle"
            ><strong>{{ rubrique.titre }}</strong
            ><small>{{ rubrique.aide }}</small></span
          >
          <span class="material-symbols-outlined chevron" aria-hidden="true">{{
            ouverte() === rubrique.id ? 'expand_less' : 'chevron_right'
          }}</span>
        </button>
        <div [id]="'synthese-' + rubrique.id" [hidden]="ouverte() !== rubrique.id" class="details">
          @if (liste.total !== 0) {
            <div class="table-scroll" tabindex="0" role="region" [attr.aria-label]="rubrique.titre">
              <table>
                <thead>
                  <tr>
                    <th scope="col">Nom de l’installation ou du parc</th>
                    <th scope="col">N° de ticket</th>
                    <th scope="col">Libellé</th>
                  </tr>
                </thead>
                <tbody>
                  @for (ticket of liste.tickets; track $index) {
                    <tr>
                      <td>{{ ticket.site }}</td>
                      <td>
                        <button
                          type="button"
                          class="ticket"
                          [disabled]="!ticket.id"
                          (click)="ouvrirTicket(ticket)"
                          [attr.aria-label]="
                            'Ouvrir le ticket ' + ticket.reference + ' — ' + ticket.site
                          "
                        >
                          {{ ticket.reference }}
                        </button>
                      </td>
                      <td>{{ ticket.issue }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            @let supplementaires = (liste.total ?? 0) - liste.tickets.length;
            @if (supplementaires > 0) {
              <p>
                {{ supplementaires }}
                {{ supplementaires === 1 ? 'élément supplémentaire' : 'éléments supplémentaires' }}
              </p>
            }
          } @else {
            <p>Aucun ticket à consulter.</p>
          }
        </div>
      </section>
    }
  }
</div>
<footer>
  <button type="button" [disabled]="chargement()" (click)="charger()">Actualiser</button>
  <button type="button" mat-dialog-close>Fermer</button
  ><button
    type="button"
    class="principal"
    [disabled]="chargement() || !!erreur()"
    (click)="voirTickets()"
  >
    Voir les tickets
  </button>
</footer>
